/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateShareLinkRequest,
  CreateShareLinkResponse,
  ListSubmittalShareLinksParams,
  RevokeShareLinksResponse,
  ShareLinkListResponse,
  ShareSessionRequest,
  ShareSessionResponse,
} from '../types';

import { axiosInstance } from '../../axiosConfig';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getShareLinks = () => {
  /**
 * Trade a share secret for a SUBMITTAL_SHARE capability (15 minutes).

401 SHARING_LINK_INVALID / SHARING_LINK_EXPIRED / SHARING_LINK_REVOKED when the secret
names no usable grant. An open records an access and the link's last use; a renewal (the
page's still-valid ``capability`` of the same link) records only the last use.
 * @summary Exchange Share Link Session
 */
  const exchangeShareLinkSession = (
    shareSessionRequest: ShareSessionRequest,
    options?: SecondParameter<typeof axiosInstance<ShareSessionResponse>>
  ) => {
    return axiosInstance<ShareSessionResponse>(
      {
        url: `/share_links/session`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: shareSessionRequest,
      },
      options
    );
  };
  /**
   * The report's active share links (and revoked/expired ones with include_inactive).
   * @summary List Submittal Share Links
   */
  const listSubmittalShareLinks = (
    campaignId: string,
    candidateId: string,
    callId: string,
    params?: ListSubmittalShareLinksParams,
    options?: SecondParameter<typeof axiosInstance<ShareLinkListResponse>>
  ) => {
    return axiosInstance<ShareLinkListResponse>(
      {
        url: `/campaigns/view/${campaignId}/candidate/${candidateId}/call/${callId}/share_links`,
        method: 'GET',
        params,
      },
      options
    );
  };
  /**
 * Mint a share link (link_kind share), or return the staff URL (link_kind staff) when
recipient_email belongs to an active org member.

400 SHARING_EXPIRY_INVALID, 403 SHARING_LINKS_NOT_ENABLED, 404 SUBMITTAL_REPORT_NOT_FOUND
when the call does not belong to the candidate on the job.
 * @summary Create Submittal Share Link
 */
  const createSubmittalShareLink = (
    campaignId: string,
    candidateId: string,
    callId: string,
    createShareLinkRequest: CreateShareLinkRequest,
    options?: SecondParameter<typeof axiosInstance<CreateShareLinkResponse>>
  ) => {
    return axiosInstance<CreateShareLinkResponse>(
      {
        url: `/campaigns/view/${campaignId}/candidate/${candidateId}/call/${callId}/share_links`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createShareLinkRequest,
      },
      options
    );
  };
  /**
 * Revoke the report's links: all of them with MANAGE_CANDIDATES on the job, otherwise only
the caller's own.
 * @summary Revoke All Submittal Share Links
 */
  const revokeAllSubmittalShareLinks = (
    campaignId: string,
    candidateId: string,
    callId: string,
    options?: SecondParameter<typeof axiosInstance<RevokeShareLinksResponse>>
  ) => {
    return axiosInstance<RevokeShareLinksResponse>(
      {
        url: `/campaigns/view/${campaignId}/candidate/${candidateId}/call/${callId}/share_links/revoke_all`,
        method: 'POST',
      },
      options
    );
  };
  /**
 * Revoke one link of this job. 404 SHARING_LINK_NOT_FOUND when the link is not this job's;
403 SHARING_REVOKE_FORBIDDEN unless the caller issued it or has MANAGE_CANDIDATES.
 * @summary Revoke Share Link
 */
  const revokeShareLink = (
    campaignId: string,
    shareLinkId: string,
    options?: SecondParameter<typeof axiosInstance<void>>
  ) => {
    return axiosInstance<void>(
      {
        url: `/campaigns/view/${campaignId}/share_links/${shareLinkId}`,
        method: 'DELETE',
      },
      options
    );
  };
  return {
    exchangeShareLinkSession,
    listSubmittalShareLinks,
    createSubmittalShareLink,
    revokeAllSubmittalShareLinks,
    revokeShareLink,
  };
};
export type ExchangeShareLinkSessionResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getShareLinks>['exchangeShareLinkSession']>
  >
>;
export type ListSubmittalShareLinksResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getShareLinks>['listSubmittalShareLinks']>
  >
>;
export type CreateSubmittalShareLinkResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getShareLinks>['createSubmittalShareLink']>
  >
>;
export type RevokeAllSubmittalShareLinksResult = NonNullable<
  Awaited<
    ReturnType<ReturnType<typeof getShareLinks>['revokeAllSubmittalShareLinks']>
  >
>;
export type RevokeShareLinkResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getShareLinks>['revokeShareLink']>>
>;
